import * as React from 'react'
import { CallFlowContainerProps } from './types'
import { CollapseFlow, Drawer, ELEMENT_TYPES } from 'prace-common-components'
import { $GridCollapseContainer } from './styles'
import { ApplicationActions } from './ApplicationActions'

export const CallFlowContainer: React.FC<CallFlowContainerProps> = ({
  isMobile,
  flow,
  workingStep,
  step,
  form,
  handleSelect,
  open,
  setOpen,
  call,
  handleOpenAssign,
  handleOpenChangeApplicant,
  selectedAssignment,
  assignments,
  setLeadAssignment,
  assignmentPartition,
  hasLead,
  handleDownloadClick,
  proposalId,
  documents,
  downloadConsolidated,
  downloadAll,
  onChangeUserVisibility,
  handleReview,
  handlePartitionChange,
  handleRequestChanges,
  handleDeadline,
  handleOpenInvite,
  handleRevoke,
  applicationId,
}) => {

  return (
    isMobile ?
      <Drawer
        maxWidth='300px'
        open={open}
        left
        noHorizPadding
        noTopPadding
        onChange={setOpen}
      >
        <CollapseFlow
          stepper
          flow={flow}
          workingStep={workingStep}
          selectedCollapse={{ type: ELEMENT_TYPES.STEP, order: step}}
          selectedElement={{ type: ELEMENT_TYPES.FORM, order: form}}
          handleSelect={handleSelect}
        />
        <ApplicationActions
          handleReview={handleReview}
          handlePartitionChange={handlePartitionChange}
          handleRequestChanges={handleRequestChanges}
          handleSelect={handleSelect}
          handleDeadline={handleDeadline}
          handleOpenAssign={handleOpenAssign}
          handleOpenChangeApplicant={handleOpenChangeApplicant}
          handleOpenInvite={handleOpenInvite}
          handleRevoke={handleRevoke}
          handleDownloadClick={handleDownloadClick}
          proposalId={proposalId}
          applicationId={applicationId}
          documents={documents || []}
          assignments={assignments}
          selectedAssignment={selectedAssignment}
          step={step}
          call={call}
          hasLead={hasLead}
          setLeadAssignment={setLeadAssignment}
          assignmentPartition={assignmentPartition}
          downloadConsolidated={downloadConsolidated}
          downloadAll={downloadAll}
          onChangeUserVisibility={onChangeUserVisibility}
        />
      </Drawer>
      :
      <$GridCollapseContainer item xs={3}>
        <CollapseFlow
          stepper
          flow={flow}
          workingStep={workingStep}
          selectedCollapse={{ type: ELEMENT_TYPES.STEP, order: step}}
          selectedElement={{ type: ELEMENT_TYPES.FORM, order: form}}
          handleSelect={handleSelect}
        />
      </$GridCollapseContainer>
  )
}
